// App
export const SET_MAIN_NAME = 'SET_MAIN_NAME'
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_DIALOG_DATA = 'SET_DIALOG_DATA'
export const SET_SUB_MAIN_DATA = 'SET_SUB_MAIN_DATA'

// Users
export const SET_MEMBER_LIST = 'SET_MEMBER_LIST'
export const SET_MANAGER_LIST = 'SET_MANAGER_LIST'
export const DELETE_MANAGER = 'DELETE_MANAGER'
export const DELETE_MEMBER = 'DELETE_MEMBER'

// CustomSetting
export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_CUSTOM_SETTING_LIST = 'SET_CUSTOM_SETTING_LIST'
export const SET_CUSTOM_SELECT_ID = 'SET_CUSTOM_SELECT_ID'
export const SET_CUSTOM_INFO_LIST = 'SET_CUSTOM_INFO_LIST'

// productCategory
export const SET_PRODUCT_CATEGORY_LIST = 'SET_PRODUCT_CATEGORY_LIST'

// productList
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST'
export const SET_PRODUCT_SELECT_ID = 'SET_PRODUCT_SELECT_ID'

// OrderList
export const SET_ORDER_LIST = 'SET_ORDER_LIST'
export const ADD_CART = 'ADD_CART'
export const ADD_CART_CUSTOM = 'ADD_CART_CUSTOM'
export const REMOVE_CART = 'REMOVE_CART'
export const REMOVE_CART_CUSTOM = 'REMOVE_CART_CUSTOM'
export const CHANGE_CART_AMOUNT = 'CHANGE_CART_AMOUNT'
export const CHANGE_CART_AMOUNT_CUSTOM = 'CHANGE_CART_AMOUNT_CUSTOM'
export const CLEAN_CART_LIST = 'CLEAN_CART_LIST'
export const SET_ORDER_SELECT_ID = 'SET_ORDER_SELECT_ID'

// Account
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO'



// WEBPACK FOOTER //
// ./src/store/mutations_type.js